// extracted by mini-css-extract-plugin
module.exports = {"MogulContainer":"style_MogulContainer__2FnQU"};